// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__oHWrs","navigation":"Navbar_navigation__0iMsd","logo":"Navbar_logo__ZBjkB","menu":"Navbar_menu__4lPHm","resume":"Navbar_resume__O-FYi"};